import {
    SET_GLOBAL_DATA,
    CUSTOMER_DATA,
    DISTRIBUTOR_DATA,
    SET_PREVGLOBAL_DATA
} from './types';
 
const setGlobalData = (globaldataValues:any) => ({
    type: SET_GLOBAL_DATA,
    globaldataValues
})

const setCustomerData = (values: any) => ({
    type: CUSTOMER_DATA,
    values
})

const setDistributorData = (values: any) => ({
    type: DISTRIBUTOR_DATA,
    values
})

const setPrevGlobalData = (globaldataValues: any) => ({
    type: SET_PREVGLOBAL_DATA,
    globaldataValues
})

export {
    setGlobalData,
    setCustomerData,
    setDistributorData,
    setPrevGlobalData
};
  